const firebaseRtdConfig = {
    apiKey: process.env.FIREBASE_RTD_API_KEY,
    authDomain: process.env.FIREBASE_RTD_AUTH_DOMAIN,
    databaseURL: process.env.FIREBASE_RTD_DATABASE_URL,
    projectId: process.env.FIREBASE_RTD_PROJECT_ID,
    storageBucket: process.env.FIREBASE_RTD_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_RTD_SENDER_ID,
    appId: process.env.FIREBASE_RTD_APP_ID
};

// export const configuration = {
//     apiKey: process.env.FIREBASE_API_KEY,
//     authDomain: process.env.FIREBASE_AUTH_DOMAIN,
//     databaseURL: process.env.FIREBASE_DATABASE_URL,
//     projectId: process.env.FIREBASE_PROJECT_ID,
//     storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.FIREBASE_SENDER_ID,
//     appId: process.env.FIREBASE_APP_ID
// };

export const configuration = firebaseRtdConfig;

export const cfRtdConfiguration = firebaseRtdConfig;

// export const b2cRecommendationConfiguration = {
//     ...firebaseRtdConfig,

// }

export const b2cRecommendationConfiguration = firebaseRtdConfig;

export const c2bVasRtdConfiguration = {
    ...firebaseRtdConfig,
    databaseURL: process.env.FIREBASE_C2B_RTD_DATABASE_URL
};
